$(document).ready(function() {
	if(!document.querySelector('.GPC0151')) return false;

	const tab_sticky = function() {
		const p = tab_sticky.prototype;
		// DOM variable
		const $this = $(".GPC0151");
		const $stickyTab = $this.find(".js-tab-category");
		// util
		const getCutLine = function(){
			const componentPositionTop = $this.offset().top;
			const cookieHeight = $('.eprivacy-cookie.ready').height() || 0;
			const culLine = componentPositionTop + (cookieHeight * -1);
			return parseInt(culLine);
		}
		// 
		$this.find('template.extra-menu-template').remove();

		// sticky by page scroll
		let	cutLine = getCutLine();

		$(window).on("resize", function(){
			p.resizeReset(); // 2022.03.04 add
			cutLine = getCutLine();
			return cutLine;
		});

		p.init = function(){
			// 2022.03.04 add
			// 20220318 - sticky 되는 엘리먼트는 comon.js의 controlStickyElements 에서 처리함 - PJTQUICKWIN 박지영
			// this.relativeCookieArea();
			this.eventOn();
		};
		// p.relativeCookieArea = function(){
		// 	const isExplicitCookie = !!ePrivacyCookies.$explicit && !ePrivacyCookies.$implicit;  
		// 	const isReadyImplicitCookie = isExplicitCookie && ePrivacyCookies.$explicit.classList.value.indexOf('ready') >= 0;
		// 	const bodyElement = document.body || 'body';
		// 	if(isReadyImplicitCookie) {
		// 		const cookieAreaIsHidden = $('.eprivacy-cookie').css('display') == 'none';
		// 		if(cookieAreaIsHidden){
		// 			$(".cookie-eu-get-height").css("height","0");
		// 			$(bodyElement).removeClass('has-cookie');
		// 		} else{
		// 			$(bodyElement).addClass('has-cookie');
		// 		}
		// 	}else{
		// 		$(bodyElement).removeClass('has-cookie');
		// 	}
		// };
		p.scrollEvent = function(type){
			cutLine = getCutLine();
			const defaultPos = parseInt(controlStickyElements.pos.GPC0151);
			const scrollPos =  $(window).scrollTop() + defaultPos;
			const stiky_condition = scrollPos >= parseInt(cutLine);
			p.scrollPosCheck(stiky_condition, type);
		};

		p.eventOn = function(){
			if($(window).scrollTop() != 0) p.scrollEvent(true);
			$(window).scroll(function(){
				p.scrollEvent();
			});
		};

		p.scrollPosCheck = function(condition, type){
			if(condition) {
				if(!$this.hasClass("sticky-active")) {
					const defaultPos = parseInt(controlStickyElements.pos.GPC0151);
					if(!type) $this.addClass("is-scroll");
					$this.addClass("sticky-active");
					$stickyTab.addClass("text-menu");
					$this.find('.mCSB_container').css({
						width: $this.find('.js-tab-guide-inner').width()
					});
					$this.find('.sticky-wrap').css("top", defaultPos);
					// 20220322 START 박지영 - Cookie가 존재하는 경우, floating 되는 순간 sticky-cookie-bg가 보이도록 수정
					if($('.sticky-cookie-bg').length > 0) $('.sticky-cookie-bg').show();
					// 2022.03.04 add
					// if($this.hasClass('has-cookie')) {
					// 	const cookieHeight = $('.cookie-banner').find('.default').height() + "px";
					// 	$this.find('.sticky-wrap').css("padding-top", cookieHeight);
					// }
				}
			} else {		
				if($this.hasClass("sticky-active")) {
					$this.removeClass("sticky-active");
					$stickyTab.removeClass("text-menu");
					$this.find('.sticky-wrap').css("top", 'inherit');
					// 2022.03.04 add
					// if($this.hasClass('has-cookie')) {
					// 	$this.find('.sticky-wrap').css("padding-top", "0");
					// }
				}		
			}
		};

		// 2022.03.04 add
		p.resizeReset = function() {
			if($this.hasClass('sticky-active') && $this.hasClass('has-cookie')) {
				const cookieHeight = $('.cookie-banner').find('.default').height() + "px";
				$this.find('.sticky-wrap').css("padding-top", cookieHeight);
			}
		};
		
		p.init();
	};
	tab_sticky();
});
